import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { dateTimeToView } from "helpers/date";
import { bidStatuses, bidStatusesEnum } from "helpers/enums/bidStatuses";
import { paths } from "helpers/paths";
import { reportFilterWrapper, SelectColumnFilter } from "helpers/reactTable";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import React from "react";
import { list as logistsList } from "sources/books/employees";
import CommonReport from "./commonReport";

const bidStatusOptions = bidStatuses
    .filter(({ value }) => ![bidStatusesEnum.New, bidStatusesEnum.Canceled].includes(value))
    .map(({ label }) => ({ label, value: label }));

export default class BidsWithRegionalFramesReport extends CommonReport {
    cellProps = (column) => ({
        Header: column.label,
        accessor: columnName(column),
        Cell: (props) => {
            const uniqueId = { [`data-${props.column.id}`.toLowerCase()]: props.row.values.bidId };
            switch (props.column.id) {
                case "bidId":
                    return (
                        <a
                            data-bidid={props.value}
                            href={paths.bidShow("bid", props.value)}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {props.value}
                        </a>
                    );
                case "firstPointPlanLeaveDate":
                case "lastPointPlanEnterDate":
                    return (
                        <span {...uniqueId}>
                            {props.value ? dateTimeToView(props.value, "DD.MM.YYYY HH:mm (Z)") : ""}
                        </span>
                    );
                default:
                    return <span {...uniqueId}>{formatValue(props.value, column.clrType)}</span>;
            }
        },
        Footer: () => this.footerVal(column),
        ...typeSpecificProps(column),
        ...(["FramesCount", "Route"].includes(column.propertyName) ? { filterable: false } : {}),
        ...(column.propertyName === "BidStatus"
            ? {
                  Filter: reportFilterWrapper((props) => (
                      <SelectColumnFilter
                          {...props}
                          selectProps={{
                              options: bidStatusOptions,
                              inputProps: { name: "bidStatus" },
                          }}
                      />
                  )),
                  filter: (rows, _id, filterValue) => {
                      if (!filterValue || !filterValue.value) {
                          return rows;
                      }
                      return rows.filter((row) => row.values.bidStatus === filterValue.value);
                  },
              }
            : {}),
        ...(column.propertyName === "LogistDisplayName"
            ? {
                  Filter: reportFilterWrapper((props) => (
                      <SelectColumnFilter
                          {...props}
                          selectProps={{
                              ...defaultMultipleSelectProps,
                              url: logistsList,
                              inputProps: { name: "logistIds" },
                              propName: "fullNameOrEmail",
                              components: { ValueContainer },
                          }}
                      />
                  )),
                  filter: (rows, _id, filterValue) => {
                      if (!filterValue || !filterValue.value || filterValue.value.length === 0) {
                          return rows;
                      }
                      return rows.filter((row) => filterValue.value.includes(row.values.logistId));
                  },
              }
            : {}),
        ...(column.propertyName === "ResponsibleDisplayName"
            ? {
                  Filter: reportFilterWrapper((props) => (
                      <SelectColumnFilter
                          {...props}
                          selectProps={{
                              ...defaultMultipleSelectProps,
                              url: logistsList,
                              inputProps: { name: "responsibleIds" },
                              propName: "fullNameOrEmail",
                              components: { ValueContainer },
                          }}
                      />
                  )),
                  filter: (rows, _id, filterValue) => {
                      if (!filterValue || !filterValue.value || filterValue.value.length === 0) {
                          return rows;
                      }
                      return rows.filter((row) => filterValue.value.includes(row.values.responsibleId));
                  },
              }
            : {}),
    });

    tableExtraProps = () => {
        const { columns } = this.props.data || {};
        const hiddenColumns = columns
            .filter((column) => column.isAdditionalColumn || column.isEntityId)
            .map(columnName);
        return { initialState: { hiddenColumns } };
    };
}
